module.exports = __webpack_public_path__ + "static/img/SC bg.32ac6eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Scratch card/SC bg.svg
// module id = u4m6
// module chunks = 1